/**
 * Spec 013 P1. The backend refuses a card that is not in the guest's own name
 * (`CARDHOLDER_NAME_MISMATCH`) or not the guest's (`PAYMENT_METHOD_NOT_OWNED`) with a
 * sentence the guest can act on. Other failures keep the generic copy.
 */
export const CARDHOLDER_NAME_MISMATCH = 'CARDHOLDER_NAME_MISMATCH';
export const PAYMENT_METHOD_NOT_OWNED = 'PAYMENT_METHOD_NOT_OWNED';
/** Spec 023: the site is not taking bookings yet; nothing was charged. */
export const BRAND_NOT_ACCEPTING_BOOKINGS = 'BRAND_NOT_ACCEPTING_BOOKINGS';

export interface CheckoutPaymentError {
  code: string | null;
  message: string;
  /** True when the guest should open the card form again and enter another card. */
  retryWithAnotherCard: boolean;
  /** Spec 023: show the "Bookings open soon" dialog with `message`, not a toast. */
  bookingsClosed?: boolean;
}

interface GraphQLErrorLike {
  message?: string;
  extensions?: { code?: unknown };
}

export function describeCheckoutPaymentError(
  error: unknown,
  fallback: string,
): CheckoutPaymentError {
  const gqlError = (error as { graphQLErrors?: GraphQLErrorLike[] } | null)?.graphQLErrors?.[0];
  const code = typeof gqlError?.extensions?.code === 'string' ? gqlError.extensions.code : null;
  const serverMessage = gqlError?.message?.trim();
  if (code === CARDHOLDER_NAME_MISMATCH || code === PAYMENT_METHOD_NOT_OWNED) {
    return {
      code,
      message: serverMessage || 'Please use a card in your own name.',
      retryWithAnotherCard: true,
    };
  }
  if (code === BRAND_NOT_ACCEPTING_BOOKINGS) {
    return {
      code,
      message: serverMessage || "Bookings aren't open yet. Your card was not charged.",
      retryWithAnotherCard: false,
      bookingsClosed: true,
    };
  }
  const message =
    serverMessage || (error instanceof Error && error.message ? error.message : fallback);
  return { code, message, retryWithAnotherCard: false };
}
